import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

export const styles = stylex.create({
  header: {
    padding: 0,
    display: 'block',
    fontFamily: fonts.din2014Demi,
    fontSize: typography['fontSizeBody-1'],
    lineHeight: typography['lineHeightBody-1'],
    color: palette['greyWhite'],
    textAlign: 'center',
    outline: 'none',
    border: 'none',
    width: '100%',
    resize: 'none',
    background: 'transparent',
    minHeight: {
      default: '32px',
      '@media (max-width: 767px)': '36px',
    },
    ':focus::placeholder': {
      opacity: 0,
    },
  },
  headerTwo: {
    fontSize: typography['fontSizeBody-2'],
    lineHeight: typography['lineHeightBody-2'],
  },
});
